import React from "react"
import Helmet from "react-helmet"
import { StaticQuery, graphql } from "gatsby"
import { Link } from "gatsby"

import index from "@modules/index.module.css"
import NebLogo from "@images/logo.png"
import compIcon from "@images/homepage/Components-Icon.svg"
import foundIcon from "@images/homepage/Foundations-Icon.svg"
import prinIcon from "@images/homepage/Principles-Icon.svg"



const IndexPage = ({ data }) => {
  const title = "Home"
  return (
  <StaticQuery
    query={graphql`
          query IndexSiteQuery {
            site {
              siteMetadata {
                title
                sidebar {
                  pages {
                    slug
                    title
                    pages {
                      slug
                      title
                    }
                  }
                }
              }
            }
          }
        `}
    render={data => (
  <div id="example" className="index">
    <Helmet
      title={
        title
          ? `${title} - ${data.site.siteMetadata.title}`
          : data.site.siteMetadata.title
      }
      meta={[
        {
          name: "description",
          content: "Documentation for Nebula",
        },
        {
          name: "keywords",
          content: "design system, style guide, documentation",
        },
      ]}
    >
      <html lang="en" id="home" />
    </Helmet>
    
<div className ="hCqF">

<div className={index.introBar}>
  <div className={index.maxWid}>
  <div className={index.siteLogo}>
  <img className={index.homeLogo} src={NebLogo} alt="Nebula logo" />
  </div>
<div className={index.introCont}>
      <p>
        Nebula is our collaborative design and build space for providing ready to use elements driven by principles, research and best practice. Nebula aims to reduce inconsistencies, speed up processes and allow products to get to market quicker by creating a unified customer experience across all our products.
      </p>
</div>
</div>
</div>
<div className={index.cntConGrid}>
<Link className={index.paraStyle} to="/principles">
  <div className={index.cntCont}>
    <img className={index.cntImage} src={prinIcon} alt="Principles" />
    <h2 className={index.heading}>Principles</h2>
    <p className={index.para}>These will give you a base to make informed design decisions that will help form a solutions that convey your communication goals.</p>
   <button className={"button " + index.ghost}>Principlces</button>
  </div>
</Link>
<Link className={index.paraStyle} to="/foundations">
  <div className={index.cntCont}>
    <img className={index.cntImage} src={foundIcon} alt="Foundations" />
    <h2 className={index.heading}>Design Foundations</h2>
    <p className={index.para}>Use our guidelines for applying colours, typography, icons and more.<br/><br/></p><br/>
   <button className={"button " + index.ghost}>Foundations</button>
  </div>
  </Link>
  <Link className={index.paraStyle} to="/components">
  <div className={index.cntCont}>
    <img className={index.cntImage} src={compIcon} alt="Components" />
    <h2 className={index.heading}>Components</h2>
    <p className={index.para}>These are the building blocks that can be used more than once to create a user interface. E.g Buttons, cards and dividers.</p>
   <button className={"button " + index.ghost}>Components</button>
  </div>
  </Link>
</div>
</div>
  </div>
    )} 
  />
)
}
export default IndexPage